import React from 'react';
import { motion } from 'framer-motion';

const Hero = () => {
  return (
    <motion.section
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
      className="h-screen flex items-center justify-center bg-cover bg-center relative overflow-hidden"
      style={{ backgroundImage: "url('/assets/images/hero-bg.jpg')" }}
    >
      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-black/30"></div>

      {/* Content */}
      <motion.div
        initial={{ y: 50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.5, duration: 1 }}
        className="text-center text-white relative z-10"
      >
        <h1 className="text-6xl font-bold mb-4 animate-pulse">
          Capturing Moments, Creating Memories
        </h1>
        <p className="text-2xl mb-8">Event Photography in the Bay Area</p>
        <motion.button
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
          className="bg-white text-gray-800 px-8 py-4 rounded-lg font-semibold hover:bg-gray-100 transition duration-300 shadow-lg"
        >
          View Gallery
        </motion.button>
      </motion.div>

      {/* Floating Images */}
      <motion.img
        src="/assets/images/floating-1.jpg"
        alt="Floating Image 1"
        className="absolute top-1/4 left-10 w-24 h-24 rounded-full shadow-lg"
        initial={{ y: -20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 1, duration: 1.5, repeat: Infinity, repeatType: 'mirror', repeatDelay: 0.5 }}
      />
      <motion.img
        src="/assets/images/floating-2.jpg"
        alt="Floating Image 2"
        className="absolute top-1/3 right-20 w-20 h-20 rounded-full shadow-lg"
        initial={{ y: -20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 1.2, duration: 1.5, repeat: Infinity, repeatType: 'mirror', repeatDelay: 0.5 }}
      />
      <motion.img
        src="/assets/images/floating-3.jpg"
        alt="Floating Image 3"
        className="absolute bottom-1/4 left-1/4 w-28 h-28 rounded-full shadow-lg"
        initial={{ y: -20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 1.4, duration: 1.5, repeat: Infinity, repeatType: 'mirror', repeatDelay: 0.5 }}
      />
    </motion.section>
  );
};

export default Hero;